import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { ClearChangeEmailUpdateResponse, changeEmailAPI } from "redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageValue } from "config/helper";

function ChangeEmail({ handleClose, setChangeEmailConfirm }) {
  const dispatch = useDispatch();
  const clientId = getLocalStorageValue("RSAclient-id");
  const storeId = getLocalStorageValue("selected-store-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");

  const { changeEmailLoading, ChangeEmailmessage } = useSelector(
    ({ user }) => user
  );

  useEffect(() => {
    dispatch(ClearChangeEmailUpdateResponse());
  }, []);

  const { register, handleSubmit, errors, clearErrors, reset, getValues } =
    useForm({
      defaultValues: { newEmail: "", confirmEmail: "" },
    });

  const handleInputChange = (fieldName) => () => {
    clearErrors(fieldName);
    dispatch(ClearChangeEmailUpdateResponse());
  };

  const changeEmailAPICall = (data) => {
    if (data?.newEmail) {
      const body = {
        RSAClientId: clientId,
        ClientStoreId: storeId,
        member_number: memberNumber,
        email_id: data.newEmail,
        user_token: userToken,
      };
      dispatch(changeEmailAPI(body, () => reset()));
    }
  };

  return (
    <div className="modalContainer">
      <div className="modal">
        <header className="modal_header" style={{borderBottom:'2px #e6e6e6 solid'}}>
          <h2 className="modal_header-title"  style={{marginBottom:'10px'}}>Change Email</h2>
        </header>
        <main className="modal_conten">
          <div className="two-col-grid container">
            <div className="two-col-grid-items row">
              <div className="form-control">
                <label>New Email*</label>
                <input
                  type="email"
                  name="newEmail"
                  id="newEmail"
                  ref={register({ required: true, pattern: /^\S+@\S+$/i })}
                  onChange={handleInputChange("newEmail")}
                />
                {errors.newEmail && (
                  <span className="text-danger display-block float-left">
                    {errors.newEmail.type === "required" &&
                      "New Email Address is required"}
                    {errors.newEmail.type === "pattern" &&
                      "The new email address entered is invalid - (e.g. email@domain.com)"}
                  </span>
                )}
              </div>
            </div>
            <div className="two-col-grid-items row">
              <div className="form-control">
                <label>Confirm Email*</label>
                <input
                  type="email"
                  name="confirmEmail"
                  id="confirmEmail"
                  ref={register({
                    required: true,
                    pattern: /^\S+@\S+$/i,
                    validate: (value) =>
                      value === getValues("newEmail") || "Emails do not match",
                  })}
                  onChange={handleInputChange("confirmEmail")}
                />
                {errors.confirmEmail && (
                  <span className="text-danger display-block float-left">
                    {errors.confirmEmail.type === "required" &&
                      "Confirm Email Address is required"}
                    {errors.confirmEmail.type === "pattern" &&
                      "The Confirm email address entered is invalid - (e.g. email@domain.com)"}
                    {errors.confirmEmail.type === "validate" &&
                      "Emails do not match"}
                  </span>
                )}
              </div>
            </div>
          </div>
        </main>

        <p style={{ color: "red", marginBottom: "1rem" }}>
          {ChangeEmailmessage}
        </p>
        <div className="expireContent"  style={{margin:'12px 0 0 0'}}>
          <footer className="modal_footer">
            <div className="modal_footer_btn">
              <div className="addBtn">
                <button
                  onClick={handleSubmit(changeEmailAPICall)}
                  rel="nofollow"
                  type="button"
                >
                  {changeEmailLoading ? "Submitting" : "Submit"}
                </button>
              </div>
              <button
                className="modal-close"
                type="button"
                onClick={() => {
                  handleClose();
                  setChangeEmailConfirm();
                }}
              >
                Close
              </button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default ChangeEmail;
